import { render } from "./BirthdayField.vue?vue&type=template&id=45b19184&scoped=true&ts=true"
import script from "./BirthdayField.vue?vue&type=script&lang=ts"
export * from "./BirthdayField.vue?vue&type=script&lang=ts"

import "./BirthdayField.vue?vue&type=style&index=0&id=45b19184&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b19184"]])

export default __exports__